import React, {useState, useEffect, useRef} from 'react';
import {makeRequest} from "../../utils/httpRequest";
import Config from "../../core/config";
import {useRecoilState} from "recoil";
import {loadingAtom} from "../../atoms";
import Cookies from "js-cookie";
import {useNavigate} from "react-router-dom";
import {findTablesByQueryString} from "../../utils/requestUtils";

const apiUrl = Config.apiUrl;
const TableList = () => {
    let [tables, setTables] = useState([]);
    const [queryString, setQueryString] = useState('');
    const inputQueryString = useRef(null);
    const [, setLoading] = useRecoilState(loadingAtom);
    const navigate = useNavigate();

    async function makeQuery(query) {
        try {
            setLoading(true);
            const response = await findTablesByQueryString(query);
            setTables(response);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (inputQueryString.current) {
            inputQueryString.current.focus();
        }
        makeQuery('');
    }, []); // Empty dependency array ensures that useEffect runs only once, similar to componentDidMount

    async function excluirMesa(id) {
        try {
            const url = apiUrl + '/api/tables/' + id;
            await makeRequest(url, 'DELETE', {'Useruuid':Cookies.get('userUUID')});
            await makeQuery(queryString);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const handleInputChange = (e) => {
        const string = e.target.value;
        if (string.length >= 3 || string.length === 0) {
            makeQuery(string);
        }
        setQueryString(string);
    };

    return (
        <>
            <div className="header-label">Consulta de Mesas</div>

            <div
                style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%'}}>
                <input ref={inputQueryString} type="text" value={queryString} onChange={handleInputChange}/>
                <button onClick={() => navigate('/table')}>Novo</button>
            </div>

            <table style={{width: '580px'}}>

                <tr>
                    <th>
                        Código
                    </th>
                    <th>
                        Nome
                    </th>
                    <th/>
                    <th/>
                    <th/>
                </tr>
                <tbody style={{overflowY: 'auto'}}>

                {tables.map((table, index) => (


                    <tr>
                        <td>
                            <div key={index}>{table.code}</div>
                        </td>
                        <td>
                            <div key={index}>{table.name}</div>
                        </td>
                        <td>
                            <button onClick={async () => {
                                await navigate('/table?id='+table.id);
                            }}>Editar
                            </button>
                        </td>
                        <td>
                            <button className="remove-button" onClick={async () => {
                                // eslint-disable-next-line no-restricted-globals
                                if (window.confirm('Deseja realmente excluir?')) {
                                    await excluirMesa(table.id);
                                }
                            }}>Excluir
                            </button>
                        </td>

                    </tr>
                ))}
                </tbody>
                {tables.length === 0 && (<tfoot>Nenhum item encontrado.</tfoot>)}
            </table>


        </>
    );
};

export default TableList;
